import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

export default function RouteAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (!measurementId || document.querySelector(`script[data-p4r-gtag="${measurementId}"]`)) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.dataset.p4rGtag = measurementId;
    document.head.appendChild(script);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', measurementId, { anonymize_ip: true, send_page_view: false });
  }, []);

  useEffect(() => {
    if (!measurementId || !window.gtag) return;
    window.gtag('event', 'page_view', {
      page_path: `${location.pathname}${location.search}`,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}
